// extracted by mini-css-extract-plugin
export default {"footer":"qqj34jnmHBC8Nj5elqyUEA==","with-payment-link":"O3uSWiqsyNqPJ0pqUgXdNw==","mollie-logo":"kxwyMrvP09rOP8-Y3Q2BIw=="};